module.exports = __webpack_public_path__ + "static/img/spring.a032e46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spring.jpg
// module id = 6N8v
// module chunks = 1